import { atom } from 'jotai';

import { RemoteI18nMaps } from '@data';

export const remoteI18nMapsAtom = atom<RemoteI18nMaps>();
export const remoteI18nMarkdownMapsAtom = atom<RemoteI18nMaps>();
